import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	CanActivateChild,
	Router,
	RouterStateSnapshot,
} from '@angular/router';
import { map, take, tap } from 'rxjs';

// --- Facades ---
import { AuthFacade } from '@facades/auth.facade';

// --- Utils ---
import { isRefreshTokenExpired } from '@utils/auth-session.util';

@Injectable({
	providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
	constructor(private _router: Router, private authFacade: AuthFacade) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.authFacade.authState$.pipe(
			take(1),
			map(({ isAuthenticated, user }) => {
				if (!isAuthenticated) {
					return { allowed: false, alreadyRedirecting: false };
				}

				if (isRefreshTokenExpired(user)) {
					// logout() already hard-redirects to /auth
					this.authFacade.logout();
					return { allowed: false, alreadyRedirecting: true };
				}

				return { allowed: true, alreadyRedirecting: false };
			}),
			tap(({ allowed, alreadyRedirecting }) => {
				if (!allowed && !alreadyRedirecting) {
					this._router.navigate(['/auth']);
				}
			}),
			map(({ allowed }) => allowed)
		);
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		return this.canActivate(route, state);
	}
}
